<template>
  <v-container fluid grid-list-md>
    <p-user-edit @onSave="userEdit" @close="closeUserEdit" ref="userEdit"></p-user-edit>
    <p-upgrade-dialog :upgradeDialog="upgradeDialog" @closeDialog="upgradeDialog = false" :link_src="`${basePath}images/upgrade_wpp.mp4`"></p-upgrade-dialog>
    <v-layout wrap justify-center align-center>
    <v-layout wrap justify-left>
      <v-flex xs12 sm6>
        <span class="headline">Configurações na empresa {{$auth.user().company.id_text | formatAbbreviation(15)}}</span>
      </v-flex>
      <v-flex xs0 sm2>
      </v-flex>
      <v-flex xs12 sm4 lg4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>
      </v-layout>
        <v-flex xs12>
          <v-card>
            <v-list>
              <v-layout>
                <v-flex xs10 lg11>
                  <v-subheader>Descrição</v-subheader>
                </v-flex>

                <v-flex xs2 lg1>
                  <v-subheader>Ações</v-subheader>
                </v-flex>
              </v-layout>
              <v-divider></v-divider>
                <v-list-tile v-for="item in filteredConfigs" :key="item.id" two-line>
                  <v-list-tile-action >
                    <v-checkbox v-model="item.active" @click.native="clickCheckboxConfig(item)"></v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                     <v-list-tile-title :style="`color: black; font-weight: bold;font-family: Arial`">
                      {{item.id_text}} {{item.id === 3 ? getMentionText() : ''}}  <p-btn-upgrade v-if="checkIsFree() && item.id === 2" style="position: absolute; top: -15px;"></p-btn-upgrade>
                    </v-list-tile-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-tooltip bottom>
                      <v-btn slot="activator" :disabled="checkIsFree() && item.id === 2" icon class="mx-0" @click="editItem(item)">
                        <v-icon color="teal">build</v-icon>
                      </v-btn>
                      <span>Editar</span>
                    </v-tooltip>
                  </v-list-tile-action>
                </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>
      <!--</v-layout>-->
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1200px" persistent scrollable>
      <v-card>
        <v-card-title primary-title>
          <span class="headline">Edição de configurações</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap justify-left align-center>
              <v-flex shrink><h3 class="black--text">{{editText}}</h3></v-flex>
              <v-flex grow v-if="type === 3">
                <v-select v-model="configs[3].mentionNotification" :items="translate('value.mention_notification')" @change="changeMentionNotification" multiple></v-select>
              </v-flex>
              <v-flex xs12 v-else-if="type > -1">
                <v-switch label="Ativo" :disabled="type === 2 ? checkIsFree() : false"
                  v-model="configs[type].active"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" color="primary darken-2" @click.native="changeConfig()">Salvar</v-btn>
          <v-btn class="mx-0" @click.native="close">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  import crud from './../../mixin/crud'
  import PUserEdit from './../shared/PUserEdit'
  import PUpgradeDialog from './../shared/PUpgradeDialog'
  import PBtnUpgrade from './../shared/PBtnUpgrade'

  export default {
    mixins: [crud],
    components: {PUserEdit, PBtnUpgrade, PUpgradeDialog},
    data: () => ({
      items: {},
      basePath: process.env.API,
      upgradeDialog: false,
      configs: [],
      dialog: false,
      type: -1,
      editText: ''
    }),
    name: 'UserConfig',
    created () {
      this.initialize()
    },
    methods: {
      initialize () {
        Object.assign(this.editedItem, this.$store.getters[`companyUserParams/values`])
        this.editedItem['mentionNotification'] = this.editedItem['mentionNotification'] ? this.editedItem['mentionNotification'] : [1, 2]
        this.configs = [{id: 0, id_text: 'Receber um e-mail diário com as minhas tarefas.', active: this.editedItem['dailyEmail']}, {id: 1, id_text: 'Abrir a tela de "Minhas Tarefas" todos os dias ao entrar pela primeira vez.', active: this.editedItem['openDaily']}, {id: 2, id_text: 'Receber mensagem via WhatsApp sobre tarefas do dia.', active: this.editedItem['dailyWpp']}, {id: 3, id_text: 'Receber notificações quando for mencionado em um comentário de alguma tarefa por: ', mentionNotification: this.editedItem['mentionNotification'], active: this.editedItem['mentionNotification'].length > 0}]
      },
      userEdit () {
        if (this.type === 2) {
          this.configs[2].active = true
          this.changeConfig()
        }
      },
      closeUserEdit () {
        if (this.type === 3) {
          this.configs[3].mentionNotification = this.configs[3].mentionNotification.filter((item) => item !== 3)
        }
      },
      // Pega o value com as opções de menção e se houver mais de um, faz a separação deles por vírgula
      getMentionText () {
        let metionAllItems = this.translate('value.mention_notification')
        let mentionOptionsText = ''
        this.editedItem['mentionNotification'].forEach((mention) => {
          let statusItem = metionAllItems[mention - 1]
          mentionOptionsText += (statusItem ? (statusItem['text'] + ', ') : '')
        })
        mentionOptionsText = mentionOptionsText.substr(0, (mentionOptionsText.length - 2))
        return mentionOptionsText
      },
      // Funcionalidade do CheckBox da opção de envio de menção, se estiver algum marcado e clicar, ambos são desativados. Se estiver desmarcado e clicar, abre tela de opção de escolha com o email e Notificação via Pop-up marcados, faltando apenas o usuario salvar.
      clickCheckboxConfig (item) {
        if (item.id === 3) {
          if (item.active) {
            this.configs[3].mentionNotification = [1, 2]
            this.editItem(item)
          } else {
            this.configs[3].mentionNotification = []
            this.changeConfig()
          }
        } else {
          this.changeConfig()
        }
      },
      // Verifica se o usuario tenta habilitar a opção de envio de menção por whatsapp e caso ele não tenha número de celular salvo, ele pede para inserir.
      changeMentionNotification (items) {
        let result = items.some((item) => item === 3)
        if (result && !this.$auth.user().phone) {
          this.$refs.userEdit.open()
          return false
        }
      },
      changeConfig () {
        if (this.configs[2].active && this.checkIsFree()) {
          this.configs[2].active = false
          this.upgradeDialog = true
        } if (this.configs[2].active && !this.$auth.user().phone) {
          this.$refs.userEdit.open()
          this.configs[2].active = false
          return
        }
        // O active da opção de envio de menção(configs[3]), sempre fica marcado se existir pelo menos uma opção de envio
        this.configs[3].active = this.configs[3].mentionNotification.length > 0
        this.editedItem = Object.assign(this.editedItem, {dailyEmail: this.configs[0].active, openDaily: this.configs[1].active, dailyWpp: this.configs[2].active, mentionNotification: this.configs[3].mentionNotification})
        // Atualiza a tela de configuração de usuario caso seja editado alguma opção de envio de menção
        setTimeout(() => {
          this.$store.commit('loader/change_dialog', true)
          this.$store.commit('companyUserParams/change_values', this.editedItem)
          this.$http.post('auth/change-user-params', {'params': JSON.stringify(this.editedItem)}).then(
            (res) => {
              this.$store.commit('loader/change_dialog', false)
            }, err => {
              console.log(err)
              this.$store.commit('loader/change_dialog', false)
              this.$store.commit('snackbar/change_values', {
                text: 'Não foi possível finalizar suas alterações, por favor reporte o erro.',
                color: 'error',
                dialog: true
              })
            })
        }, 500)
        this.dialog = false
      },
      editItem (item) {
        this.editText = item.id_text
        this.type = item.id
        this.dialog = true
      },
      close () {
        this.editText = ''
        this.type = -1
        this.dialog = false
        this.initialize()
      }
    },
    computed: {
      filteredConfigs () {
        return this.configs.filter(item => item.id_text.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').match(this.search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/details/UserConfig.vue